const discoverTabs = {
    FEATURE: 'feature',
    VIDEO: 'video',
    PAGE: 'page',
};

export default discoverTabs;
